export default __webpack_public_path__ + "static/DoL-130813c243d401bd5bec088f78e52f45.gif";